import { render } from "./ChooseLang.vue?vue&type=template&id=6e451fad&scoped=true"
import script from "./ChooseLang.vue?vue&type=script&lang=js"
export * from "./ChooseLang.vue?vue&type=script&lang=js"

import "./ChooseLang.vue?vue&type=style&index=0&id=6e451fad&scoped=true&lang=css"

import exportComponent from "E:\\项目\\5.0版本的老界面\\5.0版本的老界面\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e451fad"]])

export default __exports__